import React, { useEffect, useState } from "react";
import { otpValidation } from "../service/validation";
import { resendOtp, verifyOtp } from "../service/api";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import login_bg from "../assets/background-img/login-bg.webp";
// import { InputText } from "primereact/inputtext";
import { useLocation, useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";

export default function Otp() {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const { state } = useLocation();

  const onResend = async () => {
    const payload = {
      email: state?.email,
    };
    await resendOtp(payload).then((res) => {
      toast.success(res.message);
    });
  };

  const navigate = useNavigate();
  const onSubmit = async () => {
    try {
      const payload = {
        otp: otp,
        email: state?.email,
      };
      setLoading(true);
      await verifyOtp(payload).then((res) => {
        toast.success(res.message);
        setLoading(false);
        navigate("/login");
      });
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  useEffect(() => {
    let timer;
    if (cooldown > 0) {
      timer = setInterval(() => {
        setCooldown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [cooldown]);

  const handleClick = () => {
    if (cooldown === 0) {
      onResend(); // Trigger OTP resend logic
      setCooldown(45); // Start 45 second timer
    }
  };

  return (
    <>
      <div className="sign__main mt-[100px] w-screen h-full">
        <div className="main h-full grid  lg:grid-cols-2 gap-8 md:gap-6 place-items-center">
          <div className="sign__left h-full hidden md:block">
            <img src={login_bg} alt="" className="h-fit object-contain" />
          </div>
          <div className="sign__right w-[90%] mx-auto">
            <form className="loginform">
              <div className="sign__title">
                <h2 className="w-full pb-8">Verify Otp</h2>
              </div>
              <div className="grid grid-cols-1 gap-8 w-full">
                {/* <span className="p-float-label">
                  <InputText
                    id="otp"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    className="w-full text-center"
                  />
                  <label htmlFor="email">OTP</label>
                </span> */}
                {/* <OtpInput
                  value={values.otp}
                  onChange={handleChange}
                  numInputs={5}
                  inputStyle={''}
                  renderInput={(props) => <input {...props} />}
                /> */}
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={4}
                  inputStyle={"otp__input"}
                  inputType="tel"
                  renderInput={(props) => <input {...props} />}
                />
                {!otp && (
                  <small className="text-red-500"> Otp is required </small>
                )}
                <button
                  onClick={handleClick}
                  disabled={cooldown > 0}
                  className={`p-1 flex items-center border w-fit rounded-full gap-2 px-4 ${
                    cooldown > 0
                      ? "text-gray-400 cursor-not-allowed"
                      : "text-primary  hover:underline"
                  }`}
                >
                  {cooldown > 0 && <i className="pi pi-clock pi-spin"></i>}
                  {cooldown > 0 ? `Resend in ${cooldown}s` : "Resend OTP"}
                </button>
              </div>
            </form>
            <button
              type="submit"
              className="pri_btn w-full
                  mt-6"
              disabled={!otp || otp.length !== 4 || loading}
              onClick={onSubmit}
            >
              {loading ? <i className="pi pi-spin pi-spinner"> </i> : ""}
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
